import styled from "styled-components";

const spacing = "32px";

export const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 99;
`;

export const OverlayContainer = styled.div`
  position: absolute;
  opacity: 0.7;
  background-color: #17191b;
  width: 100%;
  height: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  max-height: 80vh;
  background-color: #fff;
  z-index: 1;
  margin-top: 10vh;
  margin-bottom: auto;
  border-radius: 8px;

  @media (max-width: 768px) {
    max-height: 90vh;
    max-width: 90vw;
    margin-top: 5vh;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing};

  h1 {
    display: -webkit-box;
    display: -moz-box;
    overflow: hidden;
    text-overflow: ellipsis;

    box-orient: vertical;
    -webkit-box-orient: vertical;

    line-clamp: 3;
    -webkit-line-clamp: 3;
    -moz-line-clamp: 3;
  }

  button {
    width: 40px;
    height: 40px;
    font-size: 28px;
    border: none;
    cursor: pointer;
    border-radius: 20px;
    background-color: unset;
    color: ${({ color }) => color};
    flex-shrink: 0;

    [class*=" cl-"] {
      font-size: 20px;
    }
  }
`;

export const SubHeader = styled.p`
  margin-top: -45px;
`;

export const Content = styled.div`
  padding: ${spacing};
  overflow: auto;
`;

export const Footer = styled.div`
  padding: ${spacing};
  border-top: 1px solid ${({ $bColor }) => $bColor};
  display: flex;
  gap: 32px;

  & > button {
    flex: 1;
  }
`;
